export const GET_INTERFACE_REQUEST = '[INTERFACES] GET_INTERFACE_REQUEST';
export const GET_INTERFACE_SUCCESS = '[INTERFACES] GET_INTERFACE_SUCCESS';
export const GET_INTERFACE_FAILED = '[INTERFACES] GET_INTERFACE_FAILED';

export const GET_INTERFACE_LIST_REQUEST = '[INTERFACES] GET_INTERFACE_LIST_REQUEST';
export const GET_INTERFACE_LIST_SUCCESS = '[INTERFACES] GET_INTERFACE_LIST_SUCCESS';
export const GET_INTERFACE_LIST_FAILED = '[INTERFACES] GET_INTERFACE_LIST_FAILED';

export const CREATE_INTERFACE_REQUEST = '[INTERFACES] CREATE_INTERFACE_REQUEST';
export const CREATE_INTERFACE_SUCCESS = '[INTERFACES] CREATE_INTERFACE_SUCCESS';
export const CREATE_INTERFACE_FAILED = '[INTERFACES] CREATE_INTERFACE_FAILED';

export const EDIT_INTERFACE_REQUEST = '[INTERFACES] EDIT_INTERFACE_REQUEST';
export const EDIT_INTERFACE_SUCCESS = '[INTERFACES] EDIT_INTERFACE_SUCCESS';
export const EDIT_INTERFACE_FAILED = '[INTERFACES] EDIT_INTERFACE_FAILED';

export const DELETE_INTERFACE_REQUEST = '[INTERFACES] DELETE_INTERFACE_REQUEST';
export const DELETE_INTERFACE_SUCCESS = '[INTERFACES] DELETE_INTERFACE_SUCCESS';
export const DELETE_INTERFACE_FAILED = '[INTERFACES] DELETE_INTERFACE_FAILED';

export const INTERFACE_SEARCH_REQUEST = '[INTERFACES] INTERFACE_SEARCH_REQUEST';
export const INTERFACE_SEARCH_SUCCESS = '[INTERFACES] INTERFACE_SEARCH_SUCCESS';
export const INTERFACE_SEARCH_FAILED = '[INTERFACES] INTERFACE_SEARCH_FAILED';

export const LOAD_INTERFACES_DETAILS_REQUEST = "[INTERFACES] LOAD_INTERFACES_DETAILS_REQUEST";
export const LOAD_INTERFACES_DETAILS_SUCCESS = "[INTERFACES] LOAD_INTERFACES_DETAILS_SUCCESS";
export const LOAD_INTERFACES_DETAILS_FAILED = "[INTERFACES] LOAD_INTERFACES_DETAILS_FAILED";

export const GET_UNIT_TYPE_LIST_REQUEST = '[INTERFACES] GET_UNIT_TYPE_LIST_REQUEST';
export const GET_UNIT_TYPE_LIST_SUCCESS = '[INTERFACES] GET_UNIT_TYPE_LIST_SUCCESS';
export const GET_UNIT_TYPE_LIST_FAILED = '[INTERFACES] GET_UNIT_TYPE_LIST_FAILED';

export const GET_CATEGORY_LIST_REQUEST = '[INTERFACES] GET_CATEGORY_LIST_REQUEST';
export const GET_CATEGORY_LIST_SUCCESS = '[INTERFACES] GET_CATEGORY_LIST_SUCCESS';
export const GET_CATEGORY_LIST_FAILED = '[INTERFACES] GET_CATEGORY_LIST_FAILED';

export const GET_ASSOCIATED_ENTITIES_LIST_REQUEST = '[INTERFACES] GET_ASSOCIATED_ENTITIES_LIST_REQUEST';
export const GET_ASSOCIATED_ENTITIES_LIST_SUCCESS = '[INTERFACES] GET_ASSOCIATED_ENTITIES_LIST_SUCCESS';
export const GET_ASSOCIATED_ENTITIES_LIST_FAILED = '[INTERFACES] GET_ASSOCIATED_ENTITIES_LIST_FAILED';

export const GET_ENTITY_LAST_READINGS_REQUEST = '[INTERFACES] GET_ENTITY_LAST_READINGS_REQUEST';
export const GET_ENTITY_LAST_READINGS_SUCCESS = '[INTERFACES] GET_ENTITY_LAST_READINGS_SUCCESS';
export const GET_ENTITY_LAST_READINGS_FAILED = '[INTERFACES] GET_ENTITY_LAST_READINGS_FAILED';

export const GET_TERMINALS_RELATED_ENTITIES_REQUEST = '[INTERFACES] GET_TERMINALS_RELATED_ENTITIES_REQUEST';
export const GET_TERMINALS_RELATED_ENTITIES_SUCCESS = '[INTERFACES] GET_TERMINALS_RELATED_ENTITIES_SUCCESS';
export const GET_TERMINALS_RELATED_ENTITIES_FAILED = '[INTERFACES] GET_TERMINALS_RELATED_ENTITIES_FAILED';

export const RESET_INTERFACE_FORM = '[INTERFACES] RESET_INTERFACE_FORM';
